import { render, staticRenderFns } from "./HotOfferIcon.vue?vue&type=template&id=ba92964c&scoped=true"
import script from "./HotOfferIcon.vue?vue&type=script&lang=js"
export * from "./HotOfferIcon.vue?vue&type=script&lang=js"
import style0 from "./HotOfferIcon.vue?vue&type=style&index=0&id=ba92964c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba92964c",
  null
  
)

export default component.exports